export default {
    'router/ROUTE_CHANGED' (state, payload) {
        if (!payload.to.matched[0]) {
            return;
        }

        let matches = _.filter(payload.to.matched, (route) => {
            return !!route.meta.claimStore;
        });

        if (!matches.length || !matches[0].meta) {
            return;
        }

        let claimStore = matches[0].meta.claimStore;

        let store;

        if (~claimStore.indexOf('/')) {
            store = claimStore.split('/').reduce((object,index) => object[index], state);
        } else {
            store = state[claimStore];
        }

        // Dirty as we manipulate the state without a commit
        store.step.currentStepIndex = payload.to.meta.step - 1;
        store.step.currentStep = store.step.steps[payload.to.meta.step - 1];
    },
    'route/ROUTE_CHANGED' (state, payload) {
        if (!payload.to.matched[0]) {
            return;
        }

        let matches = _.filter(payload.to.matched, (route) => {
            return !!route.meta.claimStore;
        });

        if (!matches.length || !matches[0].meta) {
            return;
        }

        let claimStore = matches[0].meta.claimStore;

        let store;

        if (~claimStore.indexOf('/')) {
            store = claimStore.split('/').reduce((object,index) => object[index], state);
        } else {
            store = state[claimStore];
        }

        // Dirty as we manipulate the state without a commit
        store.step.currentStepIndex = payload.to.meta.step - 1;
        store.step.currentStep = store.step.steps[payload.to.meta.step - 1];
    },
};



// WEBPACK FOOTER //
// ./src/store/mutations.js